import { fileUrl } from "@/lib/api";

export function placeImage(place) {
  if (!place) return "";
  if (place.hero_image_url) return place.hero_image_url;
  if (place.hero_file_id) return fileUrl(place.hero_file_id);
  return place.fallback_image || "";
}
